import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import AddSubscriptionButton from 'src/components/Control/Buttons/AddSubscriptionButton';
import EditSubscriptionButton from 'src/components/Control/Buttons/EditSubscriptionButton';
import DeleteSubscriptionButton from 'src/components/Control/Buttons/DeleteSubscriptionButton';
import StopResumeSubscriptionButton from 'src/components/Control/Buttons/StopResumeSubscriptionButton';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import DownloadSubscriptionButton from 'src/components/Control/Buttons/DownloadSubscriptionButton';
import ShowInvoicesForSubscriptionButton
  from 'src/components/Control/Buttons/ShowInvoicesForSubscriptionButton';
import ShowPaymentsForSubscriptionButton
  from 'src/components/Control/Buttons/ShowPaymentsForSubscriptionButton';
import { keyBy } from 'lodash';
import { SUBSCRIPTION_STATE } from 'src/models/SubscriptionModel';

const SubscriptionsToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.subscriptions] || [],
  );
  const subscriptions = useSelector(
    (state: Store) => (
      (!!state.querybuilder.recurrings && !!state.querybuilder.recurrings.result)
        ? keyBy(state.querybuilder.recurrings.result.list, 'recurrings.id') : {}
    ),
  );

  const selectedSubscription = selections.length === 1 ? subscriptions[selections[0]] : null;
  const isActive = !!selectedSubscription
    && selectedSubscription['recurrings.state'] === SUBSCRIPTION_STATE.active;

  return (
    <>
      <DeleteSubscriptionButton
        disabled={!selections.length || selections.length > 1}
        subscriptionId={selections[0]} />
      <AddSubscriptionButton />
      <EditSubscriptionButton disabled={!selections.length} />
      <StopResumeSubscriptionButton
        subscriptionId={selections[0]}
        isActive={isActive}
        disabled={!selections.length || selections.length > 1} />
      <ShowInvoicesForSubscriptionButton
        subscriptionId={selections[0]}
        disabled={selections.length !== 1} />
      <ShowPaymentsForSubscriptionButton
        subscriptionId={selections[0]}
        disabled={selections.length !== 1} />
      <ConfigureColumnsButton entity={ENTITIES.subscriptions} />
      <UnselectAllMenubutton
        entity={ENTITIES.subscriptions}
        disabled={!selections.length} />
      <DownloadSubscriptionButton />
    </>
  );
};

export default SubscriptionsToolbar;
